import AppLogo from "@/components/AppLogo";
import { cn } from "@/lib/utils";
import { useMatch } from "@tanstack/react-router";
import { ReactNode } from "react";
import HomeNavigation from "../components/_module/home/homeNavigation";

type Props = {
	children: ReactNode;
};

const AuthenticatedGuestLayout = ({ children }: Props) => {
	const settingRoute = useMatch({
		from: "/main/setting",
		shouldThrow: false,
	});

	const homeRoute = useMatch({
		from: "/main/home",
		shouldThrow: false,
	});

	const depositRoute = useMatch({
		from: "/main/deposit",
		shouldThrow: false,
	});

	const depositAmountRoute = useMatch({
		from: "/main/deposit/$cardId/amount",
		shouldThrow: false,
	});

	const newCardRoute = useMatch({
		from: "/main/card/new",
		shouldThrow: false,
	});

	const onboardingRoute = useMatch({
		from: "/main/onboarding",
		shouldThrow: false,
	});

	const activityRoute = useMatch({
		from: "/main/activity",
		shouldThrow: false,
	});

	const isSettingRoute = typeof settingRoute !== "undefined";
	const isActivityRoute = typeof activityRoute !== "undefined";
	const isHomeRoute = typeof homeRoute !== "undefined";
	const isDepositRoute = typeof depositRoute !== "undefined";
	const isAddCardRoute = typeof newCardRoute !== "undefined";

	const shouldRenderKashuLogo =
		!isSettingRoute &&
		!isHomeRoute &&
		!isDepositRoute &&
		!depositAmountRoute &&
		!isAddCardRoute &&
		typeof onboardingRoute === "undefined";

	return (
		<div className="h-full">
			<div
				className={cn(
					"container mx-auto max-w-[800px]",
					isActivityRoute && "lg:max-w-6xl xl:max-w-7xl",
				)}
			>
				{shouldRenderKashuLogo && (
					<div className="relative z-30 flex items-center justify-center py-4 h-16">
						<AppLogo />
					</div>
				)}
				{children}
			</div>
			<HomeNavigation />
		</div>
	);
};

export default AuthenticatedGuestLayout;
